const NewsList2019 = [
    {
        dt: "2019",
        my: "",
        link: "https://iittp.ac.in/annualreports",
        title: "Annual Report 2018-2019",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#survey",
        title: "News on SurviveCovid-19 Game",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "/videos/COVID-19 IITTirupati.mp4",
        title: "Innovative Solutions To Combat COVID 19 @ IIT Tirupati",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#covid",
        title: "Advisory on Covid-19",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#iitamara",
        title: "IIT Tirupati and Amara Raja Group Inks MOU",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#mip",
        title: "News on 'Mood of India Portal'",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#covid19games",
        title: "Covid 19 Awareness Games",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#covid19",
        title: "Fake news detection - COVID 19",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/On-Line Learning - ICT initiatives of MHRD and UGC.pdf",
        title: "ICT initiatives of MHRD and UGC",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "/pics/covid.png",
        title: "Students, Don't let Coronavirus stop you from learning! - MHRD",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#gowri",
        title: "Dr. Gowri’s Editorial Board Membership",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#KFC",
        title: "Student Achievement - Kerala Flood Conference",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#SSM",
        title: "26th Inter IIT Staff Sports Meet",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#wiley",
        title: "Wiley Library Awards 2019",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#swachh",
        title: "Swachh Campus Award for IIT Tirupati",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#stuawrd",
        title: "Student Awards",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "https://iittp.ac.in/mou-appcb",
        title: "MOU with APPCB and MoEF&CC, Government of India",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#hackthon",
        title: "Smart India Hackathon 2019",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#toshiba",
        title: "MOU with Toshiba R&D India",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#nvdia",
        title: "MOU with NVIDIA",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "https://iittp.ac.in/newsletter",
        title: "Newsletter Issue 2 - 2019",
        desc: ""
    },
    {
        dt: "2019",
        my: "",
        link: "#esecsrc",
        title: "ESEC/FSE 2019 ACM Student Research Competition",
        desc: ""
    }
];

export default NewsList2019;